import * as React from "react"
import { ImageSeeker } from "@ui-seeker/core"

import { useBuildExternalURL } from "@hooks"


export default function PriceEvolutionTabsMiniImageSku({ skuID, name }) {
	const { imageURL } = useBuildExternalURL({ imageData: { skuID } })
	return <ImageSeeker
		src={imageURL}
		alt={name}
		sx={{ width: 50, height: 50 }}
		containerProps={{ sx: { width: 50, height: 50, mb: 0.5 } }}
	/>
}